import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://gqkcluilnjtbulrapprh.supabase.co';
const SUPABASE_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imdxa2NsdWlsbmp0YnVscmFwcHJoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDYxNDg3NDUsImV4cCI6MjA2MTcyNDc0NX0.7ZobNqnSWmVtjYan1HOQuaHx8g2vrPbrWyaVYZ5QrCs';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
